import '../../polyfills';
import { initSimilarProductsCarousel } from './product-carousel';
import { initIncrementableInputs } from './components/incrementable-input';

document.addEventListener('DOMContentLoaded', () => {
    naja.snippetHandler.addEventListener('afterUpdate', (event) => {
        if (event.detail.snippet.id === 'snippet--cartItems') {
            initIncrementableInputs();
            initSimilarProductsCarousel();
        }
    });
});
